import {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {StoreState} from '../../type.d';
import LoadingIndicator from '../../../images/activity-loading.gif';
import {getActivityData} from '../../store/actionCreators';
import Navigation from '../../components/Navigation/Navigation';
import ActivityItem from '../../components/ActivityItem/ActivityItem';
import CircleProgressBar from '../../components/CircleProgressBar/CircleProgressBar';
import * as Styled from './YourActivityStyles';
import {Container, Row, Col} from 'react-bootstrap';
import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary';
import ErrorModal from '../../components/ErrorModal/ErrorModal';
import {EmojiWrapper} from '../../components/EmojiWrapper';

const ActivityLoading = ({ state }:any) => {
  if (state && state.data && !state.pending) {
    return null;
  }
  return (
    <Styled.LoadingContainer>
      <Styled.Img src={LoadingIndicator} />
    </Styled.LoadingContainer>
  )
}

const ActivityError = ({ state, pageError }: any) => {
  if (state.pending) {
    return null;
  }
  if (!state.data || pageError) {
    return (
      <>
        <h2>You don't have any activity yet</h2>
        <ErrorModal error={pageError} />
      </>
    );
  }
  return null;
}

const YourActivity = () => {
  const dispatch = useDispatch();
  const [pageError, setPageError] = useState<any>(null);

  const {activityState} = useSelector( (rootReducer:StoreState) => rootReducer.reducer);

  useEffect(() => {
    dispatch(getActivityData())
  },[dispatch]);

  useEffect(() => {
    setPageError(activityState.err);
  }, [activityState]);

  return (
    <Styled.Container className='YouractivityWrapper'>
      <Navigation />
      <Container fluid="xl">
        <Row>
          <Col>
            <Styled.StyledH2 className='ActivityHeader'>Your Activity</Styled.StyledH2>
          </Col>
        </Row>
        <ErrorBoundary>
          <Row>
            <Col lg={12}>
              <ActivityLoading state={activityState} />
              <ActivityError state={activityState} pageError={pageError} />
            </Col>
          </Row>
          {activityState && !activityState.pending && activityState.data &&
            <Row>
            <Col lg={4} className="order-lg-1">
              <Container fluid>
                <Row className="mt-4 justify-content-between">
                  <Col sm={6} lg={12} className='SmallWrapper'>
                    <Styled.StyledH3>Accomplishments<EmojiWrapper>&#9889;</EmojiWrapper></Styled.StyledH3>
                    <Styled.StyledParagraph className='SmallWrapperP' >Your Journey to 1,000 Searches</Styled.StyledParagraph>
                    <Styled.Container className='SearchCircleResults'>
                      <CircleProgressBar progress={activityState.data.response.accomplishments}/>
                    </Styled.Container>
                  </Col>
                  <Col sm={5} lg={12} className='SmallWrapper'>
                    <Styled.StyledH3>Feedback Contribution<EmojiWrapper>&#11088;</EmojiWrapper>️</Styled.StyledH3>
                    <Styled.StyledParagraph className='SmallWrapperP' >
                      Your feedback helps Trova to provide optimal results
                    </Styled.StyledParagraph>
                    <Styled.Container className='ShowingThumbs'>
                      <Styled.Container className='ActivityThumbs ActivityThumbsUp'>
                        <Styled.StyledH4 className='StyledH4'>
                          {activityState.data.response.thumbs_up}
                        </Styled.StyledH4>
                        <Styled.StyledParagraph className='ActivityThumbsP'>Thumbs up<EmojiWrapper>&#128077;</EmojiWrapper></Styled.StyledParagraph>
                      </Styled.Container>
                      <Styled.Container className='ActivityThumbs'>
                        <Styled.StyledH4 className='StyledH4'>{activityState.data.response.thumbs_down}</Styled.StyledH4>
                        <Styled.StyledParagraph className='ActivityThumbsP'>Thumbs down<EmojiWrapper>&#128078;</EmojiWrapper></Styled.StyledParagraph>
                      </Styled.Container>
                    </Styled.Container>
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col lg={8} className="order-lg-0">
              <Styled.Container className='LeftActivityBlock'>
                <Styled.Container>
                  {
                    activityState.data.response.today_activities ?
                      <Styled.Container>
                        <Styled.StyledH2 className='Activities'>Today</Styled.StyledH2>
                        {
                          activityState.data && activityState.data.response.today_activities.map( (e, i) => {
                            return <ActivityItem item={e} key={i} when={'today'} />;
                          })
                        }
                      </Styled.Container>
                      :
                      null
                  }
                </Styled.Container>
                <Styled.Container>
                  {
                    activityState.data.response.weekly_activities ?
                      <Styled.Container>
                        <Styled.StyledH2 className='Activities'>Weekly</Styled.StyledH2>
                        {
                          activityState.data && activityState.data.response.weekly_activities.map( (e, i) => {
                            return <ActivityItem item={e} key={i} when={'weekly'} />;
                          })
                        }
                      </Styled.Container>
                      :
                      null
                  }
                </Styled.Container>
              </Styled.Container>
            </Col>
          </Row>
          }
        </ErrorBoundary>
      </Container>
      <ErrorModal error={pageError} />
    </Styled.Container>
  )
}

export default YourActivity;